exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.venue-link[data-v-05458303] {\n  font-size: 16px;\n  text-decoration: none;\n}\n.venue-link.followed[data-v-05458303] {\n  background: linear-gradient(to right, #6146b7, #33aaeb);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n", ""]);

// exports
